import providerquickview from "./provider-quickview.html";

const quickviewHandler = require('../../../../../components/quickview/quickview-handler')
const dtHandler = require('../../../../../components/dt/dt-handler')

/****************ELEMENTS*****************/
var htmlQf = {}
var HTMLwasSelected = false

function HTMLselect(detail) {
      const sourceElement = detail.ev?.target || null;

      quickviewHandler.HTMLselect(

            'provider', //database table name****
            'provider-quickview',
            sourceElement, //source, for example AC
            providerquickview,
            htmlQf)

      HTMLwasSelected = true


}/**/

export function start(detail) {

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/

const obj = {

      show: { start: (detail) => { quickviewHandler.show(detail, htmlQf) } },
      hide: { start: (detail) => { quickviewHandler.hide(detail, htmlQf) } },

      getExtraData: { start: (detail) => { getExtraData(detail) } },
}/**/

export async function getExtraData(detail) {
      const contAverage = htmlQf.quickviewHTML.querySelector('#provider-quickview-behaivor');
      const contReport = htmlQf.quickviewHTML.querySelector('#provider-quickview-report');
      const contName = htmlQf.quickviewHTML.querySelector('#provider_quickview_name');

      if (contAverage) contAverage.innerHTML = ""; // O "" si prefieres vacío
      if (contReport) contReport.innerHTML = "";
      if (contName) contName.innerHTML = "";

      const formData = new FormData();
      if (detail.idProvider) {
            formData.append('idProvider', detail.idProvider);
      } else {
            formData.append('idPurchase', detail.idPurchase);
      }

      try {
            const result = await fetch("./server/php/queries/entityFunction/provider_behaivor.php", {
                  method: "POST",
                  body: formData,
                  credentials: 'same-origin'
            });

            if (!result.ok) throw new Error("Error en la red");

            const resultados = await result.json();

            quickviewHandler.show(detail, htmlQf);

            // Pasamos los datos a las funciones de llenado
            llenarTablaAverage(resultados.data);
            llenarTablaPayable(resultados.payable);

      } catch (err) {
            console.error("Error en la petición:", err);
      }
}

function llenarTablaAverage(datos) {
      const columns = [
            { key: 'roi', label: 'ROI', format: 'percent', behavior: true, title: 'roi_title' },
            { key: 'profit', label: 'Revenue', format: 'star', behavior: true, title: 'profit_title' },
      ];

      const html = dtHandler.dtSimpleFc(datos, columns);

      const cont = htmlQf.quickviewHTML.querySelector('#provider-quickview-behaivor');
      cont.innerHTML = ""
      cont.innerHTML = html

      return
}

function llenarTablaPayable(datos) {
      const contName = htmlQf.quickviewHTML.querySelector('#provider_quickview_name');
      contName.innerHTML = ""
      contName.innerHTML = datos.provider

      const columns = [
            { key: 'current', label: 'Current', format: 'cash', behavior: false },
            { key: 'total_due_30_days', label: '0-30d', format: 'cash', behavior: false },
            { key: 'total_due_31_to_60_days', label: '31-60d', format: 'cash', behavior: false },
            { key: 'total_due_61_to_90_days', label: '61-90d', format: 'cash', behavior: false },
            { key: 'total_due_over_90_days', label: '90+d', format: 'cash', behavior: false },
            { key: 'total_due', label: 'Total', format: 'cash', behavior: false },
      ];

      const html = dtHandler.dtSimpleFc(datos, columns);

      const cont = htmlQf.quickviewHTML.querySelector('#provider-quickview-report');
      cont.innerHTML = ""
      cont.innerHTML = html

      return
}